// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  regionId: __t.u64().name("region_id"),
  treeId: __t.u64().name("tree_id"),
  segmentId: __t.u64().name("segment_id"),
  s: __t.f64(),
  theta: __t.f64(),
  r: __t.f64(),
  updatedAt: __t.timestamp().name("updated_at"),
});
